import React from 'react';

import { Flex, PresentationalRadioGroup as RadioGroup, Text } from '@opendoor/bricks/core';

import { useMobileDevice } from 'shared/helpers/hooks/useMobileDevice';

interface IContingentSaleProps {
  isContingentSale?: string;
  onContingentSaleChange: (selection: string) => void;
}

/**
 * Buy indicates they have a contingent sale
 * storybook-check-ignore
 */
export const ContingentSale: React.FC<IContingentSaleProps> = ({
  isContingentSale,
  onContingentSaleChange,
}) => {
  const { isMobile } = useMobileDevice();
  return (
    <Flex
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      width={['90%', null, '100%']}
    >
      <Text size={isMobile ? '160' : '150'} fontWeight="medium" alignSelf="flex-start" mb={8}>
        Do you have to sell your current house before you can buy?
      </Text>
      <RadioGroup
        analyticsName="radio-group-contingent-sale"
        data-testid="radio-group-contingent-sale"
        name="contingentSale"
        onClick={onContingentSaleChange}
        selectedValue={isContingentSale}
        options={[
          {
            label: 'Yes',
            value: 'yes',
          },
          { label: 'No', value: 'no' },
        ]}
      />
    </Flex>
  );
};
